import { apiClient } from './apiClient'
import { Scorecard } from '../types/entities'
import { PaginatedResponse } from '../types/dtos'

interface GetAllScorecardParams {
  page?: number
  size?: number
  search?: string
}

export const scorecardService = {
  async getActiveScorecards(tenantId?: number, include?: string): Promise<Scorecard[]> {
    const params: Record<string, string | number> = {}
    if (tenantId) params.tenantId = tenantId
    if (include) params.include = include
    const response = await apiClient.get<Scorecard[]>('/scorecards', { params: Object.keys(params).length > 0 ? params : undefined })
    return response.data
  },

  async getScorecardById(id: number): Promise<Scorecard> {
    const response = await apiClient.get<Scorecard>(`/scorecards/${id}`)
    return response.data
  },

  async getAdminScorecardById(id: number): Promise<Scorecard> {
    const response = await apiClient.get<Scorecard>(`/admin/scorecards/${id}`)
    return response.data
  },

  async getAllScorecards(page: number = 0, size: number = 20, search: string = ''): Promise<PaginatedResponse<Scorecard>> {
    const params: GetAllScorecardParams = { page, size }
    if (search) {
      params.search = search
    }
    const response = await apiClient.get<PaginatedResponse<Scorecard>>('/admin/scorecards', { params })
    return response.data
  },

  async createScorecard(scorecardData: Record<string, unknown>): Promise<Scorecard> {
    const cleanedData = {
      ...scorecardData,
      teeSets: (scorecardData.teeSets as Array<Record<string, unknown> | undefined>)?.map(teeSet => {
        if (!teeSet) return teeSet
        const { id, ...rest } = teeSet as Record<string, unknown>
        return (id as number) < 0 ? rest : { id, ...rest }
      })
    }
    const response = await apiClient.post<Scorecard>('/admin/scorecards', cleanedData)
    return response.data
  },

  async updateScorecard(id: number, scorecardData: Record<string, unknown>): Promise<Scorecard> {
    const response = await apiClient.put<Scorecard>(`/admin/scorecards/${id}`, scorecardData)
    return response.data
  },

  async deleteScorecard(id: number): Promise<unknown> {
    const response = await apiClient.delete(`/admin/scorecards/${id}`)
    return response.data
  },

  async toggleScorecardStatus(id: number): Promise<Scorecard> {
    const response = await apiClient.patch<Scorecard>(`/admin/scorecards/${id}/status`)
    return response.data
  },

  async importEbirdieCourseForTenant(ebirdieCourseId: string, tenantId: number | null): Promise<Scorecard> {
    const response = await apiClient.post<Scorecard>('/admin/scorecards/import-ebirdie', { ebirdieCourseId, tenantId })
    return response.data
  },

  async addCourseToTenantLibrary(tenantId: number, courseId: string): Promise<Scorecard> {
    const response = await apiClient.post<Scorecard>(`/tenants/${tenantId}/course-library`, { courseId })
    return response.data
  }
}

